import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConstants } from 'src/app/core/constants';
import { IEndorseCertificateItemRequest, IEndorseCertificateItemResponse } from 'src/app/model/plan/endorse-certificate-item';
import { PreInitSettingsService } from './settings';

/**
 * Dedicated service for `POST /endorse-certificate-item`, kept separate from
 * RegisteredEquipmentService (which targets the unrelated `registered-equipment/create`
 * endpoint and its own EquipmentRequest model, written in an older
 * public-fields / Observable<any> style). Keeping the two wire contracts apart avoids
 * conflating them and lets this one follow current typed / inject() standards.
 *
 * No catchError here — this service has no meaningful fallback for a failed endorsement,
 * so the caller (CertificateItemInfoComponent) owns error presentation.
 */
@Injectable({ providedIn: 'root' })
export class CertificateEndorsementService {
  private httpClient = inject(HttpClient);
  private preInitSettingsService = inject(PreInitSettingsService);

  private get baseUrl(): string {
    const middleWare = this.preInitSettingsService.getSettings()?.middleWare;
    return `${middleWare?.middlewareUrl ?? ''}${middleWare?.accountPath ?? ''}`;
  }

  endorseCertificateItem(request: IEndorseCertificateItemRequest, isDeviceTypeChanged: boolean): Observable<IEndorseCertificateItemResponse> {
    return this.httpClient.post<IEndorseCertificateItemResponse>(`${this.baseUrl}${AppConstants.API_ENDPOINTS.EndorseCertificateItem}?isDeviceTypeChanged=${isDeviceTypeChanged}`, request);
  }
}
